import React from 'react'
import Navbar from '../Components/Navbar'
import Heroimg from '../Components/Heroimg'
import Footer from '../Components/Footer'

function Home() {
  return (
    <div>
      <Navbar/>
      <Heroimg/>
      <Footer/>
    </div>
  )
}

export default Home